var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('CampaignsHero'),_c('CampaignsFeatures'),_c('CampaignsTwoWay'),_c('CampaignsSurveys'),_c('CampaignsWorkflows'),_c('RequestDemo',{attrs:{"msg":"See how Yabbr Campaigns can supercharge your customer engagement."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }